module.exports = __webpack_public_path__ + "img/tmt.1ec96e3a.jpg";